import React, { useEffect, useState } from "react";

function colorPickerValue(value, fallback = "#1677ff") {
  const raw = String(value || "").trim();
  return /^#[0-9a-fA-F]{6}$/.test(raw) ? raw : fallback;
}

export function ActionModal({
  open,
  title,
  message,
  fields = [],
  children,
  initialValues = {},
  confirmText = "确认",
  cancelText = "取消",
  confirmClassName = "btn-primary",
  showConfirm = true,
  submitting = false,
  onCancel,
  onChange,
  onConfirm
}) {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (!open) return;
    setForm(initialValues || {});
    // 表单只在打开弹窗时初始化，避免父组件重渲染时覆盖用户已输入内容。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  async function submit(e) {
    e.preventDefault();
    if (onConfirm) {
      await onConfirm(form);
    }
  }

  function updateField(field, value) {
    const next = { ...form, [field.name]: value };
    (field.clearOnChange || []).forEach((name) => {
      next[name] = "";
    });
    setForm(next);
    if (onChange) {
      onChange(next, { name: field.name, value, field });
    }
  }

  return (
    <div className="myc-modal-backdrop" onClick={submitting ? undefined : onCancel}>
      <div className="myc-modal" onClick={(e) => e.stopPropagation()}>
        <div className="myc-modal-header">
          <h6 className="mb-0">{title}</h6>
        </div>
        <form onSubmit={submit}>
          <div className="myc-modal-body">
            {message && <div className="mb-2 text-muted">{message}</div>}
            {fields.map((f) => (
              <div className="mb-2" key={f.name}>
                <label className="form-label">{f.label}</label>
                {f.type === "select" ? (
                  <select
                    className="form-select"
                    value={form[f.name] ?? ""}
                    required={!!f.required}
                    disabled={!!f.disabled}
                    onChange={(e) => updateField(f, e.target.value)}
                  >
                    {(typeof f.options === "function" ? f.options(form) : f.options || []).map((op) => (
                      <option key={String(op.value)} value={op.value}>{op.label}</option>
                    ))}
                  </select>
                ) : f.type === "colorText" ? (
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={form[f.name] ?? ""}
                      required={!!f.required}
                      placeholder={f.placeholder || "#1677ff"}
                      disabled={!!f.disabled}
                      onChange={(e) => updateField(f, e.target.value)}
                    />
                    <input
                      type="color"
                      className="form-control form-control-color"
                      value={colorPickerValue(form[f.name], f.fallbackColor)}
                      aria-label={`${f.label}调色板`}
                      disabled={!!f.disabled}
                      onChange={(e) => updateField(f, e.target.value)}
                    />
                  </div>
                ) : (
                  <input
                    type={f.type || "text"}
                    className="form-control"
                    value={form[f.name] ?? ""}
                    required={!!f.required}
                    placeholder={f.placeholder || ""}
                    disabled={!!f.disabled}
                    onChange={(e) => updateField(f, e.target.value)}
                  />
                )}
                {f.hint && <small className="text-muted">{f.hint}</small>}
              </div>
            ))}
            {children}
          </div>
          <div className="myc-modal-footer">
            <button type="button" className="btn btn-outline-secondary" onClick={onCancel} disabled={submitting}>
              {cancelText}
            </button>
            {showConfirm && (
              <button type="submit" className={`btn ${confirmClassName}`} disabled={submitting}>
                {submitting ? "处理中..." : confirmText}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
